<template>
  <div id="content-wrap" style="text-align: center; padding: 10px;">
    <div v-if="isChecking">
      <h3><i>Verifing you Email Address ...</i></h3>
      <h3>Please wait!!</h3>
      <br /><br /><br /><br /><br /><br />
    </div>
    <div v-else-if="isVerified">
      <h1>Thank You!</h1>
      <h3 style="color: green;">Your Email Address is now verified!!</h3>
      <h3>We sent you an email "How To" use <b style="color:#367fa9;">Printer Counters</b></h3>
      <div><i>(Please check you email inbox)</i></div>
      <br />
      <h3>To login click here: <b style="color:#367fa9;"><a href="#" @click="$root.goto('Login')">Login</a></b></h3>
    </div>
    <div v-else>
      <h1>Sorry!!</h1>
      <h3 style="color: red;">Your Email Address verification is failed!!</h3>
      <div v-if="error">
        <h4 style="color: red;">{{error}}</h4>
      </div>
      <br /><br />
      <h4 v-if="isResend"><a href="#" @click="resendVerification()">Re-Send Verification email</a></h4>
    </div>
    
    <br />
    <loading :active.sync="$root.isLoading"></loading>
  </div>
</template>
<script>
  import { db } from '../../firebase'
  import Loading from 'vue-loading-overlay'
  import short from 'short-uuid'
  export default {
    name: 'verify',
    components: { Loading },
    data () {
      return {
        currentVerification: {},
        isChecking: true,
        isVerified: false,
        isResend: false,
        error: ''
      }
    },
    created () {
      this.CheckVerifcationCode()
    },
    methods: {
      CheckVerifcationCode () {
        let vm = this
        console.log('CheckVerifcationCode() ... ')
        vm.$root.isLoading = true
        vm.error = ''
        let email = vm.$route.query.Email
        let code = vm.$route.query.Code
        if (email) {
          if (code) {
            vm.isVerified = true
            let now = vm.$moment()
            db.ref('Verifications').orderByChild('Email').equalTo(email).once('value').then(function (snapVerification) {
              let data = snapVerification.val()
              // var childKey = childSnapshot.key;
              // var childData = childSnapshot.val();
              console.log(data)
              if (data) {
                let keys = Object.keys(data)
                vm.currentVerification = data[keys[0]]
                vm.currentVerification.UID = keys[0]
                if (vm.currentVerification.Code === code) {
                  vm.isVerified = true
                  vm.isChecking = false
                  vm.isResend = false
                  db.ref('Users/' + vm.currentVerification.UID + '/Verified').set(true)
                  db.ref('Verifications/' + vm.currentVerification.UID).remove()

                  db.ref('Users/' + vm.currentVerification.UID).once('value').then(function (snapUser) {
                    let userData = snapUser.val()
                    console.log(userData)
                    if (userData) {
                      userData['.key'] = vm.currentVerification.UID
                      let contact = {
                        Logged: now.format('YYYY-MM-DD HH:mm:ss'),
                        LoggedInt: Number(now.format('YYYYMMDDHHmm')),
                        FullName: userData.FirstName + ' ' + userData.LastName,
                        Email: email,
                        Message: 'System Message: New Dealer account was created.',
                        IsRead: false
                      }
                      db.ref('Contact').push(contact)
                    }
                  })
                  vm.$root.isLoading = false
                  console.log('Success.')
                } else {
                  vm.isVerified = false
                  vm.isChecking = false
                  vm.isResend = true
                  vm.$root.isLoading = false
                  vm.error = '* Wrong Verification Code, Please try again!'
                  // vm.error = ''
                  console.log('Error 500 : ' + vm.error)
                }
              } else {
                vm.isVerified = false
                vm.isChecking = false
                vm.isResend = true
                vm.$root.isLoading = false
                vm.error = '* Failed to read your data! Please contact System Administrator!'
                // vm.error = ''
                console.log('Error 400 : ' + vm.error)
              }
            })
          } else {
            vm.isVerified = false
            vm.isChecking = false
            vm.isResend = true
            vm.$root.isLoading = false
            console.log('Error 300 : We could Not detect your Verification Code!!')
          }
        } else {
          console.log('Error 200')
          vm.isVerified = false
          vm.isChecking = false
          vm.isResend = false
          vm.$root.isLoading = false
          vm.error = 'We could Not detect your email address!!'
          console.log('Error 200 : ' + vm.error)
        }
      },
      resendVerification () {
        let vm = this
        let translator = short()
        let verifyCode = translator.generate()
        var now = vm.$moment()
        var nextWeek = now.add(7, 'days')
        let verify = {
          Created: now.format('YYYYMMDDHHmmss'),
          Expired: nextWeek.format('YYYYMMDDHHmmss'),
          Email: vm.$route.query.Email,
          Code: verifyCode
        }
        if (vm.currentVerification.UID) {
          db.ref('Verifications/' + vm.currentVerification.UID).set(verify)
        } else {
          db.ref('Verifications').push(verify)
        }

        let emailData = {
          // SendTo: 'abedali1977@gmail.com',
          SendTo: vm.$route.query.Email,
          Subject: 'Verify your email for Printer Counters - Thank you',
          Template: 'verify.html',
          TemplateData: {
            FirstName: vm.firstName,
            LastName: vm.lastName,
            Date: now.format('DD/MM/YYYY HH:mm:ss'),
            VerifcationEmail: vm.$route.query.Email,
            VerifcationCode: verifyCode
          }
        }

        let query = '?Data=' + JSON.stringify(emailData)
        let urlWithQuery = 'https://us-central1-b-info.cloudfunctions.net/SendEmail' + query
        // let urlWithQuery = 'http://localhost:5001/b-info/us-central1/SendEmail' + query
        var request = { url: urlWithQuery, method: 'get', responseType: 'json' }
        vm.$axios(request).then(function (response) {
          vm.$notify({
            type: 'success',
            title: 'Verification Email',
            text: 'We sent you another verification email, Please check your inbox'
          })
        }).catch(function (error) {
          callback({ Success: false, Data: error })
          vm.$notify({
            type: 'danger',
            title: 'Failed to send an Email',
            text: error
          })
        })
      },
      SendWelcomeEmail (vm, emailData, callback) {
        console.log('SendWelcomeEmail')
        let query = '?Data=' + JSON.stringify(emailData)
        let urlWithQuery = 'https://us-central1-b-info.cloudfunctions.net/SendEmail' + query
        // let urlWithQuery = 'http://localhost:5001/b-info/us-central1/SendEmail' + query
        var request = { url: urlWithQuery, method: 'get', responseType: 'json' }
        vm.$axios(request).then(function (response) {
          callback({ Success: false, Data: response.data })
        })
          .catch(function (error) {
            callback({ Success: false, Data: error })
          })
      }
    }
  }

</script>
<style>
  #service {
    background-color: #ecf0f5;
  }
</style>



// WEBPACK FOOTER //
// Verify.vue?ba6eea4a